import { useFormik } from "formik";
import { EditCustomerPhoneValidation } from "global/Validation/Validation";
import BuildingIcon from "../../../../../assets/icons/BuildingIcon";
import UserIcon from "../../../../../assets/icons/UserIcon";
import CustomSelectElement from "../../../../../global/CustomSelectElement/CustomSelectElement";
import InputText from "../../../../../global/InputText/InputText";
import SimpleButton from "../../../../../global/SimpleButton/SimpleButton";
import { addEditUrls } from "../../../../../services/api.enums";
import { addEditDataAPI } from "../../../../../services/CRUDServices";

const EditCustomerPhone = ({
  currentData,
  handleSuccess,
  setCustomer,
}: any) => {
  const formik = useFormik({
    initialValues: {
      telNumber: currentData?.telephones?.at(-1)?.telNumber
        ? currentData?.telephones?.at(-1)?.telNumber
        : "",
    },
    validationSchema: EditCustomerPhoneValidation,
    onSubmit: (values) => {
      addEditDataAPI(addEditUrls.telephone, "post", {
        isActive: true,
        telNumber: values.telNumber,
        selectPhoneType: {
          id: 0,
          text: "",
        },
        selectCustomer:
          currentData.type === "CUSTOMER" ? { id: currentData.id } : undefined,
        selectResponseProspect:
          currentData === "PROSPECT" ? { id: currentData.id } : undefined,
      }).then(({ data }) => {
        setCustomer({ ...currentData, telephones: [{ id: data.payload.id }] });
        handleSuccess();
      });
    },
  });

  const { values, errors, touched, handleChange, handleSubmit } = formik;

  const handleCloseEdit = () => handleSuccess();

  const ReceiverCustomerType = [
    {
      title: "حقیقی",
      icon: (
        <UserIcon
          className={`${currentData.customerType.id === 0 ? "!text-dark" : ""}`}
        />
      ),
      active: 0,
    },
    {
      title: "حقوقی",
      icon: (
        <BuildingIcon
          className={`${currentData.customerType.id === 1 ? "!text-dark" : ""}`}
        />
      ),
      active: 1,
    },
  ];
  return (
    <form onSubmit={handleSubmit}>
      <CustomSelectElement
        className="!w-full cursor-auto"
        options={ReceiverCustomerType}
        step={currentData.customerType.id}
      />
      <InputText
        values={currentData.name}
        wrapperClassName="w-full"
        label="نام و نام خانوادگی"
      />
      {currentData.customerType.id === 0 ? (
        <InputText
          values={currentData.nationalCode}
          wrapperClassName="w-full"
          label="کد ملی"
        />
      ) : (
        <InputText
          values={currentData.nationalId}
          wrapperClassName="w-full"
          label="شناسه ملی"
        />
      )}
      <InputText
        values={values.telNumber}
        name="telNumber"
        handleChange={handleChange}
        wrapperClassName="w-full"
        label="تلفن همراه"
        error={touched.telNumber && errors.telNumber}
      />
      <div className="btnForm">
        <SimpleButton
          handelClick={handleCloseEdit}
          text="لغو"
          className="full-lightTomato-btn w-full"
        />
        <SimpleButton
          type="submit"
          text="تایید"
          className="full-tomato-btn w-full"
        />
      </div>
    </form>
  );
};

export default EditCustomerPhone;
